import type { ISingleTreeChildGroup } from './SingleTreeFilter';
import { RectangleFilterItemBox } from '../RectangleFilterItemBox/RectangleFilterItemBox';
import { RectangleFilterItem } from '../RectangleFilterItem/RectangleFilterItem';
import { Typography } from '@banhala/ui-kit';

type BigCategoryProps = {
  categoryList: ISingleTreeChildGroup['entity']['possibleItems'];
  handleClickItem: (newValue: string) => void;
};
export const BigCategory = ({
  categoryList,
  handleClickItem,
}: BigCategoryProps) => {
  return (
    <RectangleFilterItemBox key={Math.random()}>
      {categoryList.map(({ queryValue, text, isSelected, ...rest }) => {
        return (
          <RectangleFilterItem
            key={`${text}-${queryValue}`}
            isSelected={isSelected}
            onPress={() => handleClickItem(queryValue)}
          >
            <Typography type="subtitle3" color="content_primary">
              {text}
            </Typography>
            <Typography
              type="subtitle3"
              color="content_tertiary"
              marginLeft={2}
            >
              {rest.countText}
            </Typography>
          </RectangleFilterItem>
        );
      })}
    </RectangleFilterItemBox>
  );
};
